// extracted by mini-css-extract-plugin
export default {"newsList":"index_newsList_wS2De","fontBolder":"index_fontBolder_YurrD"};